import React, { createContext } from "react";

const MetaWindow24hContext = createContext();

export default MetaWindow24hContext;
